<template>
  <v-app>
    <v-app-bar app color="info" dark>
      <v-toolbar-title class="info text-white"
        >CONFIRMAR EL PROCESO DE VALIDACIÓN</v-toolbar-title
      >
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-card>
              <v-card-title
                ><p v-if="!showcheck">Codigo de validación</p>
                <p v-if="showcheck">Su codigo ha sido varificado</p>
              </v-card-title>
              <v-card-text>
                <div v-if="showspnipper">
                  <Spinner message="Procesando..." size="large"> </Spinner>
                </div>
                <div v-if="showcheck">
                  <v-img
                    :src="logo"
                    width="80"
                    height="80"
                    contain
                    class="d-flex justify-center align-center"
                  >
                  </v-img>
                </div>

                <v-form>
                  <v-text-field
                    v-model="codigo"
                    label="Código de Validación"
                    required
                  ></v-text-field>
                  <v-btn @click="validarCorreo()" color="primary"
                    >Validar</v-btn
                  >
                  <v-btn
                    v-if="showcheck"
                    @click="toinicio()"
                    color="success"
                    class="ml-2"
                    >Ir a inicio
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>

            <v-card v-if="resultado !== null">
              <v-card-title>Resultado</v-card-title>
              <v-card-text>
                <p>{{ resultado.mensaje }}</p>
                <p v-if="resultado.error" class="error-text">
                  {{ resultado.error }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      showspnipper: false,
      showcheck: false,
      resultado: null,
      codigo: "",
      logo: require("@/assets/logo/check-mark.png"),
    };
  },
  mounted() {
    const codigo = this.$route.params.codigo;
    this.codigo = codigo;
    //     //console.log(this.codigo);
    // this.validarCorreo(codigo);
  },
  methods: {
    async validarCorreo() {
      try {
        if (!this.codigo) {
          console.error("Código no válido");
          return;
        }
        this.showspnipper = true;
        const response = await axios({
          method: "get",
          url: "ApiWeb/Validarcorreo.php",
          params: {
            codigo: this.codigo,
          },
        });
        //const fullURL = response.config.url;
        //    //console.log("URL completa:", fullURL);

        if (response.data.error) {
          this.makeToast(response.data.mensaje, "warning");
        } else {
          this.showspnipper = false;
          this.showcheck = true;
          this.makeToast(response.data.mensaje, "success");
          //console.log("Me validaron correctamente.");
        }
      } catch (error) {
        console.error(error);
      }
    },
    toinicio() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
}
</style>
